import React from 'react';
import {Button, Modal} from 'antd-mobile';
const isMobile = /Android|iPhone|iPod|iPad/i.test(navigator.userAgent);
const isMobileBrowser = isMobile && !/MicroMessenger|AlipayClient|FSBrowser/i.test(navigator.userAgent);

class ButtonEl extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false
        }
    }
    submit = (e)=>{
        e.preventDefault();
        let props = this.props;
        let form = props.form;
        form.validateFieldsAndScroll({scroll: {offsetTop: 60}},(err, data)=>{
            if (err){
                console.log(err);
                return;
            }
            
            if (isMobileBrowser && props.payment_amount) {
                const alertInstance = Modal.alert('', $st('手机浏览器只能提交表单，无法进行支付'), [
                    { text: $st('取消'), onPress: () => alertInstance.close(), style: 'default' },
                    { text: $st('确定'), onPress: () => {
                        props.submitForm && props.submitForm(data);
                    } }]
                );
            }else {
                props.submitForm && props.submitForm(data);
            }
        });
        e.stopPropagation();
    }
    render(){
        let {api_name, label, is_show, payment_amount} = this.props;
        let isSubmit = api_name === 'button_submit';
        if (isSubmit && payment_amount) {
            label = $st('提交并支付')+ '( ' + payment_amount.toFixed(2) + ' )';
        };
        let tempProps = {
            name: api_name,
            type: isSubmit ? 'primary' : '',
            onClick: isSubmit && this.submit,
            className: !isSubmit && 'j-reset'
        }
        return (is_show !== false ? <Button {...tempProps}>{label}</Button> : null)
    }
}

export default ButtonEl;


// WEBPACK FOOTER //
// ./src/component/Button.js